module.exports = __webpack_public_path__ + "static/img/s48.fe3ce0b6.png";